import { useContext } from 'react';
import { SearchEnvironmentContext } from '../contexts';

export const useSearchEnvironment = () => {
  return useContext(SearchEnvironmentContext);
};
